import type { GlossaryTerm } from '@/content/types';
const normalise = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’']/g, '');
export function filterGlossary(terms: GlossaryTerm[], query = '', topic = 'All terms', letter = 'All') {
  const words = normalise(query).trim().split(/\s+/).filter(Boolean);
  return terms.filter(t => (topic === 'All terms' || t.category === topic) && (letter === 'All' || t.term[0].toUpperCase() === letter) && words.every(w => normalise([t.term, t.definition, t.example, ...(t.aliases ?? [])].filter(Boolean).join(' ')).includes(w)));
}
